const openEnded = {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "open-ended",
    items: [
      { id: "q1", question: "Der Text der Eingabeaufforderung 1", answers: [], image: null },
      { id: "q2", question: "Der Text der Eingabeaufforderung 2", answers: [], image: null },
      { id: "q3", question: "Der Text der Eingabeaufforderung 3", answers: [], image: null },
      { id: "q4", question: "Der Text der Eingabeaufforderung 4", answers: [], image: null },
      { id: "q5", question: "Der Text der Eingabeaufforderung 5", answers: [], image: null },
    ],
  },
  botId: "nualang.open-ended.0.0.1",
  botName: "open_ended",
  description: "open_ended_desc",
  difficulty: "ALL",
  learnLang: "german",
  name: "",
  botAvatar: "",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-comment-dots?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: `# Willkommen
   
  Sag "Hallo" zu bot, um zu beginnen.`,
  voice: "",
  versionQuestion: "Wie viele Fragen möchten Sie in dieser Vorlage haben?",
};

export default openEnded;
